import { render, staticRenderFns } from "./AutoSendSwitch.vue?vue&type=template&id=5f6f702b&scoped=true"
import script from "./AutoSendSwitch.vue?vue&type=script&lang=js"
export * from "./AutoSendSwitch.vue?vue&type=script&lang=js"
import style0 from "./AutoSendSwitch.vue?vue&type=style&index=0&id=5f6f702b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f702b",
  null
  
)

export default component.exports